export interface ParsedSseChunk {
  events: string[];
  remainder: string;
}

export const MAX_SSE_EVENT_CHARS = 256 * 1024;

export function updateEventBuffer<T>(
  current: T[],
  incoming: T[],
  replace: boolean,
  maxEvents: number,
): T[] {
  return (replace ? incoming : [...current, ...incoming]).slice(-maxEvents);
}

export function parseSseChunk(
  buffer: string,
  chunk: string,
  maxEventChars = MAX_SSE_EVENT_CHARS,
): ParsedSseChunk {
  const blocks = `${buffer}${chunk}`.split(/\r?\n\r?\n/);
  const remainder = blocks.pop() ?? "";
  const oversized = blocks.find((block) => block.length > maxEventChars) ??
    (remainder.length > maxEventChars ? remainder : undefined);
  if (oversized !== undefined) {
    throw new RangeError(`SSE event exceeds ${maxEventChars} characters`);
  }
  const events = blocks.flatMap((block) => {
    const data = block
      .split(/\r?\n/)
      .filter((line) => line.startsWith("data:"))
      .map((line) => line.slice(5).trimStart())
      .join("\n");
    return data ? [data] : [];
  });
  return { events, remainder };
}
